import React from 'react';
import { Link } from 'react-router-dom';

function VisaGuides() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .visa-guides-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Step-by-Step International Medical Visa Guidelines: Delhi NCR Private Healthcare Entry Manual
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Planning a medical trip can be stressful. Securing the proper sovereign immigration approvals is the most critical operational gateway to your treatment path. Whether you are researching advanced cardiothoracic bypass surgeries, robotic joint reconstructions, or targeted oncology protocols, traveling under the correct visa classification protects your legal status and ensures uninterrupted clinical care.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By tracking regulatory parameters on independent informational directories like <strong>Medical Trip World</strong>, global travelers can find out how to secure an official Visa Invitation Letter (VIL) required for fast-track medical visa stamping without administrative friction.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Pre-Travel Immigration & Cost Guides →
        </Link>
      </div>

      {/* SECTION 1: CORE IMMIGRATION TYPES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          The Electronic Indian Medical Visa Framework
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Sovereign electronic immigration portals maintain highly efficient entry pipelines engineered explicitly for international health consumers. The triple-entry <strong>e-Medical Visa</strong> allows multiple entries within a 60-day validity window, making it highly practical for handling primary surgeries, intermediate clinical assessments, and subsequent post-op recovery tracking.
        </p>
        <p style={{ color: '#555', lineHeight: '1.7', margin: 0, fontSize: '0.95rem' }}>
          To support the patient during their stay, up to two close companions can travel under an accompanying <strong>e-Medical Attendant Visa</strong>. Unlike state-run public networks, elite private multi-specialty hospital groups in New Delhi, Gurgaon, and Noida house dedicated corporate international wings that generate the verified letters required to clear these digital application runs quickly.
        </p>
      </section>

      {/* SECTION 2: DOCUMENTATION CHECKLIST MATRIX */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Mandatory Documentation Checklist for Patient & Attendant Visas
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          To prevent administrative delays or processing rejections at global consulates, traveling families must compile their data profiles in strict accordance with standard entry requirements:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Documents Checklist for Patient & Attendant Visa:</h3>
          <ol style={{ lineHeight: '2', marginTop: '10px', paddingLeft: '20px', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>Valid Passport Framework:</strong> Must hold a valid passport with at least 6 months validity from the date of travel and house a minimum of two blank entry stamp pages.</li>
            <li style={{ marginBottom: '8px' }}><strong>Official Local Diagnostics:</strong> Comprehensive medical diagnosis reports from local hometown doctors detailing your underlying conditions clearly in English.</li>
            <li style={{ marginBottom: '8px' }}><strong>Certified Visa Invitation Letter (VIL):</strong> A formal, stamped medical visa invitation letter generated directly by a licensed private partner hospital.</li>
            <li style={{ marginBottom: '0' }}><strong>Proof of Financial Solvency:</strong> Certified bank entries, cross-border wire documentation, or statement parameters covering treatment and stay duration logistics completely.</li>
          </ol>
        </div>
      </section>

      {/* SECTION 3: POST-ARRIVAL FRRO REGULATIONS - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Post-Discharge Compliance: Foreign Regional Registration (FRRO)
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates strictly as an open informational venue and independent directory index, we remind international travelers to proactively manage their post-arrival administrative safety markers:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Mandatory 14-Day FRRO Filing</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              All overseas health travelers must submit a local tracking file to the online Foreign Regional Registration Office (FRRO) within 14 days of landing. Private hospital international care wings process this requirement digitally on your behalf.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Independent Verification Rights</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              International consumers maintain the absolute right to cross-reference all hospital invitation data structures directly with their chosen private facility to verify document validity before traveling.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Medical Visa Guidelines
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can a patient undergo major surgical operations while holding a tourist visa?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Sovereign immigration regulations strictly dictate that foreign passport holders entering the country for purposeful medical interventions must hold a proper Medical Visa. Initiating invasive operations or checking into private multi-specialty centers under a tourist visa is completely illegal and violates national clinical care rules.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>What is the typical timeline required for a digital e-Medical Visa to be approved?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Once your formal application is loaded into the secure sovereign immigration portal alongside your private hospital invitation letter, electronic visa clearances are typically processed and issued to your email within 72 to 96 business hours.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World process visa applications or interface with immigration offices?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not process immigration applications, manage visa stubs, or issue official medical invitation letters. All invitation documentation, financial quote mapping, and clinical care obligations happen directly and solely between the patient and their independently selected private medical provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="visa-guides-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="visa-guides-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default VisaGuides;